export enum ContentType {
  Image = 'image',
  Video = 'video',
  Text = 'text',
}
